import "react-day-picker/lib/style.css"
import "./RangeDayPicker.css"

import { useCallback, useState } from "react"
import DayPicker from "react-day-picker"

import { formatToLocalDateTime } from "web/services/helpers"
import { fromMonth, toMonth, YearMonthForm } from "./"

export const INITIAL_STATE = {
  from: null,
  to: null,
  enteredTo: null, // Keep track of the last day for mouseEnter.
}

// Helpful if you just want to use the data picker
export function useRangeDayPickerState() {
  return useState(INITIAL_STATE)
}

const isSelectingFirstDay = (from, to, day) => {
  const isBeforeFirstDay = from && day < from
  const isRangeSelected = from && to
  return !from || isBeforeFirstDay || isRangeSelected
}

export default function RangeDayPicker({
  onChange,
  value: { from, to, enteredTo },
}) {
  const fromInDateTime = formatToLocalDateTime(from)
  const toInDateTime = formatToLocalDateTime(to)
  const enteredToDateTime = formatToLocalDateTime(enteredTo)

  const [date, setDate] = useState(
    !!fromInDateTime ? fromInDateTime.toJSDate() : new Date()
  )

  const handleDayClick = useCallback(
    (day) => {
      const dayInDateTime = formatToLocalDateTime(day)
      if (isSelectingFirstDay(fromInDateTime, toInDateTime, dayInDateTime)) {
        onChange({
          from: dayInDateTime.toISODate(),
          to: null,
          enteredTo: null,
        })
      } else {
        onChange({
          from,
          to: dayInDateTime.toISODate(),
          enteredTo: dayInDateTime.toISODate(),
        })
      }
    },
    [from, fromInDateTime, onChange, toInDateTime]
  )

  const handleDayMouseEnter = useCallback(
    (day) => {
      const dayInDateTime = formatToLocalDateTime(day)
      if (!isSelectingFirstDay(fromInDateTime, toInDateTime, dayInDateTime)) {
        onChange({
          to,
          from,
          enteredTo: day,
        })
      }
    },
    [from, fromInDateTime, onChange, to, toInDateTime]
  )

  const fromInJSDate = fromInDateTime
    ? fromInDateTime.toJSDate()
    : fromInDateTime
  const enteredToInJSDate = enteredToDateTime
    ? enteredToDateTime.toJSDate()
    : enteredToDateTime

  const modifiers = {
    start: fromInJSDate,
    end: enteredToInJSDate,
  }
  const disabledDays = { before: fromInJSDate }
  const selectedDays = [
    fromInJSDate,
    { from: fromInJSDate, to: enteredToInJSDate },
  ]

  return (
    <DayPicker
      className="Range"
      month={date}
      fromMonth={fromMonth}
      toMonth={toMonth}
      selectedDays={selectedDays}
      disabledDays={disabledDays}
      modifiers={modifiers}
      onDayClick={handleDayClick}
      onDayMouseEnter={handleDayMouseEnter}
      captionElement={({ date, localeUtils }) => (
        <YearMonthForm
          date={date}
          localeUtils={localeUtils}
          onChange={setDate}
        />
      )}
    />
  )
}
